( function( $, document, window ) {
	'use strict';

	function combineClass( className, blockId ) {
		return `${className}-${blockId}`;
	}

	function checkOverflow(swiperInstance) {
		const class_name = 'swiper--no-navigation'
		if (swiperInstance.isBeginning && swiperInstance.isEnd) {
			// All slides are visible, add a class to hide navigation
			swiperInstance.el.classList.add( class_name );
		} else {
			// Not all slides are visible, ensure navigation is shown
			swiperInstance.el.classList.remove( class_name );
		}
	}

	$( function() {
		$( '.js-team-card-collection' ).each( function( index, element ) {
			const blockId = $(this).data('block-id');

			const config = {
				activeClass: 'is-active',
				carouselEl: combineClass( '.js-carousel', blockId ),
				paginationEl: combineClass( '.js-carousel-pagination', blockId ),
			};

			const $pagination = $( config.paginationEl );

			new Swiper( config.carouselEl, {
				direction: 'horizontal',
				spaceBetween: 16,
				slidesPerView: 'auto',
				loop: false,
				watchOverflow: true,
				centerInsufficientSlides: true,

				pagination: {
					el: config.paginationEl,
					clickable: true,
				},

				on: {
					init: function () {
						checkOverflow(this);
					},
					resize: function () {
						checkOverflow(this);
					},
				}
			});
		});
	} );

} )( jQuery, document, window );
